import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="container-page flex min-h-[70vh] flex-col items-center justify-center py-28 text-center">
        <p className="font-heading text-6xl leading-none text-accent-500/30 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">这一页不在剧情里</h1>
        <p className="mt-3 text-sm text-foreground-600">
          你访问的地址 <span className="font-mono text-xs text-foreground-500">{location.pathname}</span>{" "}
          可能已被移动或从未存在。
        </p>
        <p className="mt-2 max-w-md text-sm text-foreground-500">
          可以回到首页，或者直接去章节分类页挑一个想看的段落。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-home-4-line text-base leading-none" />
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-400"
          >
            <i className="ri-list-check text-base leading-none" />
            浏览章节
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}